import { OuterBoxBase } from '../../components/outerBox'

export class _OuterBoxCustom extends OuterBoxBase {
  cssType!: 'default' | 'small' | 'larger'
  protected initPC(): this {
    this['--outer-box-main-width'] = '1.7rem'
    this['--outer-box-main-height'] = '2.26rem'
    this['--hover-move-top-translateY'] = '-0.1rem'
    return this
  }
  protected initH5(): this {
    this['--outer-box-main-width'] = '1.6rem'
    this['--outer-box-main-height'] = '2.12rem'
    this['--hover-move-top-translateY'] = '-0.1rem'
    return this
  }
}
